import React from 'react';
import {Avatar} from 'material-ui';
import classNames from 'classnames';
import moment from 'moment';
import { connect } from 'react-redux';
import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroller';
import {Form} from 'react-form';
import { injectIntl } from 'react-intl';

import Translate from 'translate';
import {FormGroup, Text, Select, DatePicker, Checkbox} from 'components/FormElements';
import DirectMessageModal from 'routes/app/components/Agent/DirectMessageModal/';

class ContactsTab extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      dmModalOpened: false,
    };

    this.toggleDmModal = this.toggleDmModal.bind( this );
    this.formData = { typeSearch: 'allCriteriaCustomer' }
  }

  toggleDmModal( contact ) {
    if( contact ) this.channelUidSelected = contact.channelUid;
    this.setState( { dmModalOpened: !this.state.dmModalOpened } )
  }

  onSearch = ( values ) => {
    const { onSearch, contacts } = this.props;
    this.formData = _.cloneDeep( values );
    onSearch( values );
  };

  render() {
    const { contacts, loadChannel, options, onOpenChannel, loadMore, onSearch, intl, chatActive, phoneActive } = this.props;

    const optionsSelect = [
      { id: 'allCriteriaCustomer', name: <Translate id="All"/> },
      { id: 'criteriaCustomer', name: <Translate id="Name"/> },
      { id: 'words', name: <Translate id="Words"/> },
      { id: 'emailAccountCustomer', name: 'Email' },
      { id: 'twAccountCustomer', name: 'Twitter' },
      { id: 'fbAccountCustomer', name: 'Facebook' },
      { id: 'walk_in', name: 'Walkin' },
    ];

    if (phoneActive){
      optionsSelect.splice(1,0,{ id: 'phoneCustomer', name: <Translate id="Phone"/>  });
    }

    const total = parseInt( contacts.total || '0' );
    const formattedContacts = _.chain( contacts.data )
      .groupBy( dateObj => moment( dateObj.updatedAt ).format( 'DD/MM/YYYY' ) ).value();

    return (
      <div className="box-body box-body-contacts p-3">
        <Form onSubmit={this.onSearch} defaultValues={this.formData || {}}>
          {( { getValue, submitForm } ) =>
            <form onSubmit={submitForm}>
              <div className="row">
                <FormGroup containerClass="col-md-8">
                  <Select field="typeSearch" className="form-control" placeholder=""
                          options={optionsSelect}/>
                </FormGroup>
                <FormGroup containerClass="col-md-8">
                  <Text field="value" className="form-control" placeholder="typeToSearch"/>
                </FormGroup>

                <div className="col-md-4 text-right">
                  <button className="btn btn-info"><Translate id="submit"/></button>
                </div>
              </div>
            </form>
          }
        </Form>

        <InfiniteScroll
          pageStart={0}
          loadMore={loadMore}
          hasMore={contacts.data ? contacts.data.length < total : false}
          loader={<div className="loader" key={0}><Translate id="loading"/>...</div>}
          useWindow={false}
          threshold={20}
        >
          <div className="ui-timline-container ui-timline-left theme-light timeline-sm">
            <section className="ui-timeline">
              {_.map( formattedContacts, ( contacts, date ) =>
                <div key={date}>
                  <article className="tl-item">
                    <div className="tl-body">
                      <div className="tl-entry">
                        <div className="tl-caption">
                          <a href="javascript:;" className="btn btn-primary btn-block">{date}</a>
                        </div>
                      </div>
                    </div>
                  </article>

                  {_.map( contacts, ( item, index ) =>
                    <article key={index} className="tl-item">
                      <div className="tl-body">
                        <div className="tl-entry">
                          <div className="tl-icon">
                            <Avatar src={item.webPathThumbnail}/>
                          </div>
                          <div className="row m-0">
                            <div className="col-xl-8 col-12 p-0">
                              <p className="m-0 text-underline pointer"
                                 onClick={() => loadChannel( item )}>
                                <i className={classNames( 'fa mr-2', {
                                  'fa-facebook-square color-facebook': item.type === 'facebook',
                                  'fa-twitter-square color-twitter': item.type === 'twitter',
                                  'fa-phone-square': item.type === 'phone',
                                  'fa fa-envelope color-danger': item.type === 'email',
                                  'fa fa-user': item.type === 'walk_in',
                                } )}/>
                                {item.name}
                              </p>
                              {item.type === 'facebook' &&
                              <span className="text-small text-muted">{item.faceId}</span>}
                              {item.type === 'twitter' &&
                              <span className="text-small text-muted">{item.twId}</span>}
                              {item.type === 'phone' &&
                              <span className="text-small text-muted">{item.phone}</span>}
                            </div>
                            <div className="col-xl-4 col-12 text-right pr-0">
                            <span className="text-small text-muted">
                              {moment( item.updatedAt ).format( 'h:mm A' )}
                            </span>

                              <br/>
                              {(item.type !== 'phone' && item.type !== 'chat') ?
                              <button className="btn btn-sm btn-outline-secondary"
                                      onClick={() => this.toggleDmModal( item )}>
                                <i className="fa fa-comment"/>
                              </button> : <br/>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </article>
                  )}
                </div>
              )}
            </section>
          </div>
        </InfiniteScroll>

        <DirectMessageModal open={this.state.dmModalOpened}
                            onClose={this.toggleDmModal}
                            channelUid={this.channelUidSelected}
                            options={options}
                            onOpenChannel={onOpenChannel}
        />

      </div>
    )
  }
}


const mapStateToProps = ( state ) => ( {
  chatActive: state.settings.chatActive,
  phoneActive: state.settings.phoneActive,
} );

module.exports = connect(
  mapStateToProps
)( ContactsTab );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ContactsTab/index.js